<div class="progress-bar">
    <div class="progress" [style.width.%]="progress * 100">
    </div>
</div>
